/* Menu + search behaviour — deferred, cached across pages. */

/* ============================================================
   STENCIL MENU (snippets/menu-drawer.liquid)
   ============================================================ */
(function(){
  var menu=document.getElementById('mobMenu'); if(!menu) return;
  var folds=[].slice.call(menu.querySelectorAll('.ulm-fold'));
  function closeAll(){ folds.forEach(function(f){ f.classList.remove('is-open'); f.querySelector('.ulm-row').setAttribute('aria-expanded','false'); }); }
  folds.forEach(function(f){
    var btn=f.querySelector('.ulm-row');
    btn.addEventListener('click',function(){
      var open=!f.classList.contains('is-open'); closeAll();
      if(open){ f.classList.add('is-open'); btn.setAttribute('aria-expanded','true');
        setTimeout(function(){ f.scrollIntoView({block:'nearest',behavior:'smooth'}); },320); }
    });
  });
  var obs=new MutationObserver(function(){
    var open=menu.classList.contains('open');
    menu.setAttribute('aria-hidden',open?'false':'true');
    if(!open){ setTimeout(function(){ closeAll(); var s=menu.querySelector('.ulm-scroll'); if(s) s.scrollTop=0; },400); }
  });
  obs.observe(menu,{attributes:true,attributeFilter:['class']});
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&menu.classList.contains('open')&&window.closeMobileMenu) closeMobileMenu(); });
  menu.addEventListener('click',function(e){ var a=e.target.closest('a[href]'); if(a&&window.closeMobileMenu) closeMobileMenu(); });
})();

/* ============================================================
   THE LOOKUP — search (snippets/search-overlay.liquid)
   ============================================================ */
(function(){
  var root=document.getElementById('ulSearch'); if(!root) return;
  var input=document.getElementById('ulsIn'), form=document.getElementById('ulsForm'), hint=document.getElementById('ulsHint'),
      idle=document.getElementById('ulsIdle'), res=document.getElementById('ulsResults'), cols=document.getElementById('ulsCols'),
      list=document.getElementById('ulsList'), all=document.getElementById('ulsAll'), none=document.getElementById('ulsNone'),
      recentBox=document.getElementById('ulsRecent'), recentList=document.getElementById('ulsRecentList'),
      clearBtn=document.getElementById('ulsClear'), forget=document.getElementById('ulsForget');
  var searchUrl=root.getAttribute('data-search-url')||'/search';
  var RK='urbanleb_recent', timer=null, seq=0, lastQ='', hi=-1, opener=null, kbHint='<span class="uls-kb"><kbd>↑↓</kbd> pick · <kbd>↵</kbd> open · <kbd>esc</kbd> close</span>';
  var ROTS=['-3deg','2deg','-1.5deg','3deg','-2.5deg','1.5deg'];

  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function money(v){var n=parseFloat(v); if(isNaN(n)) return esc(v); return '$'+(Math.round(n*100)/100).toFixed(2).replace(/\.00$/,'');}
  function thumb(u){ if(!u) return ''; return u.replace(/(\.[a-z]{3,4})(\?.*)?$/i,'_160x200_crop_center$1'); }
  function mark(title,q){
    var t=esc(title); if(!q) return t;
    var words=q.trim().split(/\s+/).filter(Boolean).map(function(w){return w.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');});
    if(!words.length) return t;
    return t.replace(new RegExp('('+words.join('|')+')','ig'),'<mark>$1</mark>');
  }
  function show(el,on){ if(el) el.hidden=!on; }
  function setHint(html,busy){ hint.innerHTML=html; hint.classList.toggle('is-busy',!!busy); }

  /* ---- recent searches (this browser only) ---- */
  function getRecent(){ try{ return JSON.parse(localStorage.getItem(RK)||'[]'); }catch(e){ return []; } }
  function remember(q){ q=q.trim(); if(q.length<2) return; try{ var r=getRecent().filter(function(x){return x.toLowerCase()!==q.toLowerCase();}); r.unshift(q); localStorage.setItem(RK,JSON.stringify(r.slice(0,6))); }catch(e){} }
  function paintRecent(){
    var r=getRecent(); show(recentBox,r.length>0);
    recentList.innerHTML=r.map(function(q){return '<button type="button" class="uls-chip" data-q="'+esc(q)+'">'+esc(q)+'</button>';}).join('');
  }
  recentList.addEventListener('click',function(e){ var b=e.target.closest('[data-q]'); if(!b) return; input.value=b.getAttribute('data-q'); onInput(); input.focus(); });
  forget.addEventListener('click',function(){ try{localStorage.removeItem(RK);}catch(e){} paintRecent(); });

  /* ---- open / close ---- */
  function open(){
    if(root.classList.contains('open')) return;
    opener=document.activeElement;
    if(window.closeMobileMenu) try{closeMobileMenu();}catch(e){}
    if(window.closeCartDrawer) try{closeCartDrawer();}catch(e){}
    paintRecent();
    root.classList.add('open'); root.setAttribute('aria-hidden','false'); document.body.classList.add('uls-open');
    setHint(input.value?'':'Type a brand, a piece, a colour '+kbHint);
    try{ input.focus({preventScroll:true}); }catch(e){ input.focus(); }
  }
  function close(){
    if(!root.classList.contains('open')) return;
    root.classList.remove('open'); root.setAttribute('aria-hidden','true'); document.body.classList.remove('uls-open');
    if(opener&&opener.focus) try{opener.focus({preventScroll:true});}catch(e){}
  }
  window.ulSearch={open:open,close:close,toggle:function(){ root.classList.contains('open')?close():open(); }};
  root.addEventListener('click',function(e){ if(e.target.closest('[data-uls-close]')) close(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&root.classList.contains('open')){ e.preventDefault(); close(); } });
  /* "/" anywhere on the page opens search, like the pros */
  document.addEventListener('keydown',function(e){
    if(e.key!=='/'||e.metaKey||e.ctrlKey||e.altKey) return;
    var t=e.target; if(t&&(t.tagName==='INPUT'||t.tagName==='TEXTAREA'||t.isContentEditable)) return;
    e.preventDefault(); open();
  });

  /* ---- typing → predictive results ---- */
  function onInput(){
    var q=input.value; root.classList.toggle('has-q',q.length>0);
    clearTimeout(timer);
    if(q.trim().length<2){ lastQ=''; showIdle(); return; }
    setHint('Looking…',true);
    timer=setTimeout(function(){ lookup(q.trim()); },160);
  }
  function showIdle(){ show(idle,true); show(res,false); show(none,false); hi=-1; setHint(input.value?'Keep typing…':'Type a brand, a piece, a colour '+kbHint); }
  function lookup(q){
    var my=++seq; lastQ=q;
    var url=searchUrl+'/suggest.json?q='+encodeURIComponent(q)
      +'&resources[type]=product,collection&resources[limit]=8&resources[limit_scope]=each'
      +'&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,variants.title,tag';
    fetch(url,{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(d){
      if(my!==seq) return;
      var r=(d&&d.resources&&d.resources.results)||{}; paint(q,r.products||[],r.collections||[]);
    }).catch(function(){ if(my===seq) setHint('Connection hiccup — press ↵ to search anyway'); });
  }
  function paint(q,products,collections){
    show(idle,false); hi=-1;
    all.href=searchUrl+'?q='+encodeURIComponent(q)+'&type=product&options%5Bprefix%5D=last';
    all.querySelector('i').textContent=q;
    if(!products.length&&!collections.length){
      show(res,false); show(none,true); none.querySelector('i').textContent=q;
      setHint('Nothing under “'+esc(q)+'” — try another word');
      return;
    }
    cols.innerHTML=collections.slice(0,6).map(function(c,i){
      return '<a href="'+esc(c.url)+'" class="uls-stk'+(i===0?' uls-stk--ice':'')+'" style="--r:'+ROTS[i%ROTS.length]+';--j:'+i+'"><span>'+esc(c.title)+'</span></a>';
    }).join('');
    list.innerHTML=products.map(function(p,i){
      var img=p.featured_image&&p.featured_image.url?thumb(p.featured_image.url):'';
      var was=p.compare_at_price_max&&parseFloat(p.compare_at_price_max)>parseFloat(p.price)?'<s>'+money(p.compare_at_price_max)+'</s>':'';
      var out=p.available===false?'<em>Sold out</em>':'';
      return '<a href="'+esc(p.url)+'" class="uls-it" role="option" style="--j:'+i+'">'
        +(img?'<img src="'+esc(img)+'" alt="" loading="lazy" width="62" height="76">':'<span></span>')
        +'<span><span class="uls-it-t">'+mark(p.title,q)+'</span>'+(p.type?'<span class="uls-it-v">'+esc(p.type)+'</span>':'')+'</span>'
        +'<span class="uls-it-p">'+was+money(p.price)+out+'</span></a>';
    }).join('');
    show(none,false); show(res,true);
    var n=products.length, c=collections.length;
    setHint((n>=8?'8+':n)+' piece'+(n===1?'':'s')+(c?' · '+c+' collection'+(c===1?'':'s'):'')+' '+kbHint);
  }
  input.addEventListener('input',onInput);
  clearBtn.addEventListener('click',function(){ input.value=''; onInput(); input.focus(); });

  /* ---- keyboard: walk the list ---- */
  function items(){ return res.hidden?[]:[].slice.call(list.querySelectorAll('.uls-it')).concat([all]); }
  function setHi(i){
    var its=items(); its.forEach(function(el){el.classList.remove('is-hi');});
    hi=Math.max(-1,Math.min(i,its.length-1));
    if(hi>=0){ its[hi].classList.add('is-hi'); its[hi].scrollIntoView({block:'nearest'}); }
  }
  input.addEventListener('keydown',function(e){
    if(e.key==='ArrowDown'){ e.preventDefault(); setHi(hi+1); }
    else if(e.key==='ArrowUp'){ e.preventDefault(); setHi(hi-1); }
    else if(e.key==='Enter'&&hi>=0){ e.preventDefault(); var el=items()[hi]; if(el){ remember(input.value); location.href=el.href; } }
  });
  form.addEventListener('submit',function(e){
    if(input.value.trim().length===0){ e.preventDefault(); input.focus(); return; }
    remember(input.value);
  });
  list.addEventListener('click',function(){ remember(input.value); });
  all.addEventListener('click',function(){ remember(input.value); });

  /* ---- swipe down on the top bar closes (phone) ---- */
  var sy=null, top=root.querySelector('.uls-top');
  top.addEventListener('touchstart',function(e){ sy=e.touches[0].clientY; },{passive:true});
  top.addEventListener('touchend',function(e){ if(sy!=null&&e.changedTouches[0].clientY-sy>70) close(); sy=null; },{passive:true});
})();
